import React, { useState } from 'react';
import { Header, Wrapper } from './index.styles';
import DialogImage from 'components/dialog/dialog-image';
import {IEKYCUserDocument} from "../../../../../../types/entities/users";

const DocumentComponent = ({
 kycData,
 title,
}: {
  kycData: IEKYCUserDocument;
  title: string;
}) => {
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [dialogImage, setDialogImage] = useState('');

  const { imageData } = kycData;

  return (
    <Wrapper>
      <Header>
        <h4>{title}</h4>
      </Header>
      <img
        src={`data:${imageData.type};base64,${imageData.content}`}
        alt={imageData.name}
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setDialogImage(`data:${imageData.type};base64,${imageData.content}`);
          setImageDialogOpen(true);
        }}
      />
      <DialogImage
        isDialogOpen={imageDialogOpen}
        setIsDialogOpen={setImageDialogOpen}
      >
        <img src={dialogImage} alt="full preview" />
      </DialogImage>
    </Wrapper>
  );
};

export default DocumentComponent;
